import { useState, useCallback } from "react";
import axios from "axios";

const useFetch = () => {
  const [state, setState] = useState({
    data: null,
    loading: false,
    error: null,
  });

  const fetchData = useCallback(async (url, options = {}) => {
    setState((prev) => ({ ...prev, loading: true, error: null }));

    try {
      const response = await axios.get(url, options);
      setState({
        data: response.data,
        loading: false,
        error: null,
      });
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message ||
        "An error occurred while fetching data";
      setState({
        data: null,
        loading: false,
        error: errorMessage,
      });
      throw error;
    }
  }, []);

  const resetState = useCallback(() => {
    setState({
      data: null,
      loading: false,
      error: null,
    });
  }, []);

  return {
    data: state.data,
    loading: state.loading,
    error: state.error,
    fetchData,
    resetState,
  };
};

export default useFetch;
